/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Galileo Computing VueJS Dashboard
  Author: Ian Kibet
  Author URL: http://ian.galileoc.co.ke
==========================================================================================*/

import vm from '../../main.js'

import axios from "@/axios.js"
import store from "@/store/store.js"
const {
  endpoint
} = require('@/../config.js');

export default {
  addSale({
    commit
  }, sale) {
    return new Promise((resolve, reject) => {
      var timestamp = Date.now();
      return vm.$pouch
        .put({
            _id: `${sale.branch._id}:${timestamp}`,
            amount: sale.amount,
            discount: sale.discount,
            branch: sale.branch,
            products: sale.products_raw,
            payment: sale.payment_method,
            cashier: vm.$session.get('user')._id,
            type: "sale",
            date_created: timestamp,
            date_updated: timestamp,
          }, {},
          "express"
        ).then((res) => {
          if (res.ok) {
            return vm.$pouch.bulkDocs(
              sale.products_raw, {},
              "express"
            ).then((res2) => {
              return resolve(res);
            }).catch((err) => {
              return reject(err);
            });
          } else {
            return resolve(res);
          }
        })
    })
  },
  fetchSale({
    commit
  }, s) {
    return new Promise((resolve, reject) => {
      axios.get(endpoint + "/sales/" + s + "/")
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchSaleItems({
    commit
  }, s) {
    return new Promise((resolve, reject) => {
      axios.get(endpoint + "/api/sales/sale/" + s + "/items/")
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchSales({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get(endpoint + "/sales/")
        .then((response) => {
          commit('SET_SALES', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateSale({
    commit
  }, method) {
    return new Promise((resolve, reject) => {
      axios.patch(endpoint + `/sales/${method.id}/`, method)
        .then((response) => {
          commit('UPDATE_SALE', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeSale({
    commit
  }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(endpoint + `/sales/${itemId}/`)
        .then((response) => {
          commit('REMOVE_SALE', itemId)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },


}